import { Fragment, Suspense } from "react";
import { Route, Routes as RouterRoutes } from "react-router-dom";
import withErrorBoundary from "../../Common/hocs/withErrorBoundary";
import PATHS, { authenticationFlowPaths } from "../paths";
import NoComponentFound from "../views/NoComponentFound";
import RenderableView from "./RenderableView";

function Routes({ setPageAppHeader, setContainerSize, loading }) {
  let RoutesToRender = PATHS.map((pathInformation, index) => (

    <Route
      key={`route${encodeURIComponent(pathInformation.title)}#${index}`}
      path={pathInformation.path}
      element={
        <RenderableView
          pathInformation={pathInformation}
          setPageAppHeader={setPageAppHeader}
          setContainerSize={setContainerSize}
        />
      }
    />
  ));

  return (
    <Fragment>
      <Suspense fallback={<div>Loading</div>}>
        <RouterRoutes>
          {authenticationFlowPaths.map(({ path, Component }, index) => (
            <Route
              key={`route${encodeURIComponent(path)}#${index}`}
              path={path}
              element={<Component />}
            />
          ))}
          {RoutesToRender}
          <Route path="*" element={<NoComponentFound />} />
        </RouterRoutes>
      </Suspense>
    </Fragment>
  );
}

export default withErrorBoundary(Routes);
